import React from 'react';
import { NavLink } from 'react-router-dom';
import { FiHome, FiBookOpen, FiBell, FiUsers, FiMoreHorizontal } from 'react-icons/fi';
import './ParentMobileNavigation.css';

const mobileNavItems = [
  { to: '/parent/overview', icon: FiHome, label: 'Overview' },
  { to: '/parent/assignments', icon: FiBookOpen, label: 'Assignments' },
  { to: '/parent/alerts', icon: FiBell, label: 'Alerts' },
  { to: '/parent/students', icon: FiUsers, label: 'Students' },
  { to: '/parent/courses', icon: FiMoreHorizontal, label: 'More' },
];

function ParentMobileNavigation() {
  return (
    <nav className="parent-mobile-nav" aria-label="Parent Portal mobile navigation">
      {mobileNavItems.map(item => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            `parent-mobile-nav__item ${isActive ? 'parent-mobile-nav__item--active' : ''}`
          }
        >
          <item.icon className="parent-mobile-nav__icon" size={20} />
          <span className="parent-mobile-nav__label">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}

export default ParentMobileNavigation;
